// Shared constants across pages
export const CONTRACT_TYPES = [
  "Full-time",
  "Part-time",
  "Freelance",
  "Consultant",
  "Internship",
];

export const SECTORS = [
  "Administration",
  "Construction",
  "Customer Service",
  "Education",
  "Engineering",
  "Finance",
  "Healthcare",
  "Hospitality",
  "HR",
  "Logistics",
  "Marketing",
  "Retail",
  "Sales",
  "Security",
  "Tech",
  "Transport",
  "Other",
];
